module.exports = __webpack_public_path__ + "static/media/others.23411867.png";